/**
 * Offline status banner.
 *
 * Shows a thin yellow ribbon at the top of the screen when the browser
 * reports navigator.onLine === false. AI-powered stages (Hear, Say) fail
 * gracefully without network; static stages (Meet, Draw) work fully
 * offline as long as the service worker has cached the letter assets.
 */

import { useEffect } from 'preact/hooks';
import { signal } from '@preact/signals';

export const online = signal(navigator.onLine ?? true);

let wired = false;
function wireOnce() {
  if (wired) return;
  wired = true;
  window.addEventListener('online', () => (online.value = true));
  window.addEventListener('offline', () => (online.value = false));
}

export function OfflineBanner() {
  useEffect(wireOnce, []);

  if (online.value) return null;

  return (
    <div
      role="status"
      class="fixed top-0 inset-x-0 z-50 bg-sun text-ink text-center py-2 text-sm font-display shadow-md"
    >
      <span>📶 لَا يُوجَدُ إِنْتِرْنِتْ</span>
      <span class="ms-2 opacity-70" dir="ltr">
        — AI stages will wait until you're back online
      </span>
    </div>
  );
}
